// extracted by mini-css-extract-plugin
export default {"textarea":"form-textarea_textarea__FV4xS","error":"form-textarea_error__dLzuO","error-message":"form-textarea_error-message__xwRwf"};